<template>
   <div class="footerMessage magTop20">
      <div class="footerMessageM">
        <!-- <p>
          <br>
        </p> -->
        <p
          class="text-center"
          style="color: rgb(102, 102, 102); text-align: center;"
        >技术支持：长沙甜甜圈信息科技有限公司</p>
        <!-- <p class="text-center" style="color: rgb(102, 102, 102); text-align: center;">
          <img src="/static/safe.png" title="ghs.png" alt="ghs.png">&nbsp;湘公网安备 43010302000710号
        </p> -->
      </div>
    </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>

  /*底部信息*/
  .footerMessage {
    width: 100%;
    background: #262626;
    color: #979797;
    font-size: 13px;
    z-index: 1000;
    padding: 10px 0;
    text-align: center;
  }
  .footerMessageM {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .footerMessageM .mapEnter {
    position: absolute;
    right: 0;
    bottom: 10px;
  }
  .footerMessageM .mapEnter img {
    width: 80px;
  }
  .footerMessage p {
    padding: 2px 0;
  }
  .footerMessage p a {
    padding: 0 3px;
    color: #b6b6b6;
  }
  .footerMessage p a:hover {
    color: #2ea7e0;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue